<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" :toName="title" cneterName="合作伙伴" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="内容类型">
          <a-radio-group v-model="ruleForm.type">
            <a-radio :value="1">链接</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="图片" prop="imageUrl">
          <a-upload
            name="file"
            :multiple="false"
            :action="uploadFileUrl"
            :fileList="fileList"
            :limit="1"
            @change="onUploadChange"
            :before-upload="handleBefore"
          >
            <a-button>
              <a-icon type="upload"/>
              上传文件
            </a-button>
            <span class="image-hint">温馨提示：图片建议上传尺寸为1920px*630px，格式.jpg、.png、.jpeg</span>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="图片描述" prop="imageDescription">
          <a-input placeholder="请输入" v-model="ruleForm.imageDescription" style="max-width:500px" :maxLength="20"/>
        </a-form-model-item>

        <a-form-model-item label="链接" prop="linkAddress">
          <a-input v-model="ruleForm.linkAddress" placeholder="需以http://或https://开头" :maxLength="225"
                   style="max-width:500px"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'AddCooperativePartner',
  components: {
    Breadcrumb
  },
  mixins: [ruleFormMixins],

  data() {
    let handleContent = (rule, value, callback) => {
      if (value && (value.indexOf('http://') >= 0 || value.indexOf('https://') >= 0)) {
        callback()
      } else if (value) {
        callback(new Error('输入的链接不合法'))
      }
    }
    return {
      ruleForm: {
        type: 1,
        imageUrl: undefined,
        imageDescription: '',
        linkAddress: ''
      },
      rules: {
        imageUrl: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        imageDescription: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        linkAddress: [{ required: true, validator: handleContent, trigger: 'blur' }]
      },
      fileList: [],
      imageUrl: '',
      submitLoading: false,
      disabledDate(current) {
        return current && current < moment().startOf('day')
      },
      uploadFileUrl: '',
      id: '',
      title: '添加'
    }
  },
  mounted() {
    let appConfig = this.getAppConfig()
    this.uploadFileUrl = appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
  },
  activated() {
    this.id = this.$route.query.id
    this.fileList = []
    this.title = this.id ? '编辑' : '添加'
    if (this.id) {
      this.getDetails()
    }
    this.goReset()
  },
  methods: {
    getDetails() {
      let url = 'pc/v2/partnership/' + this.id
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.ruleForm.imageDescription = res.imageDescription
          this.ruleForm.imageUrl = res.imageUrl
          this.ruleForm.linkAddress = res.linkAddress
          this.ruleForm.type = res.type
          this.fileList = [{
            uid: '-1',
            name: res.imageUrl,
            status: 'done',
            url: res.imageUrl
          }]
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        imageDescription: this.ruleForm.imageDescription,
        imageUrl: this.ruleForm.imageUrl,
        linkAddress: this.ruleForm.linkAddress,
        type: this.ruleForm.type,
        id: this.id
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/partnership/save', parms).then(res => {
        this.$message.success('保存成功')
        this.submitLoading = false
        this.goBack()
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    onUploadChange(file) {
      if (file.file.status != 'removed') {
        this.fileList = [...file.fileList]
        this.fileList = this.fileList.slice(-1)
        this.fileList.forEach(file => {
          // 因为只有一个，所以可以用
          if (file.response) {
            this.ruleForm.imageUrl = file.response.data
          }
        })
      } else {
        this.fileList = []
        this.imageUrl = ''
        setTimeout(() => {
          this.ruleForm.imageUrl = undefined
        }, 300)
      }
    },
    handleBefore(file) {
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>